import { render, staticRenderFns } from "./BlockedPhone.vue?vue&type=template&id=c76ec9a6&scoped=true"
import script from "./BlockedPhone.vue?vue&type=script&lang=js"
export * from "./BlockedPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76ec9a6",
  null
  
)

export default component.exports